/**
 * 정오 표기 컨트롤 — styled(페이지 로컬, Phase 2 FilterBar·룰 상세 NoteTextarea 선례).
 * @spec:2026-09-29-처방검토-판정기록-조회화면
 */
import styled from "styled-components";
import { COLOR_SYSTEM } from "components/design/design-system";

export const LabelWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 10px 12px;
  margin-top: 8px;
  border: 1px solid ${COLOR_SYSTEM.get("Gray")?.[100]};
  border-radius: 8px;
  background-color: ${COLOR_SYSTEM.get("Gray")?.[0]};
`;

export const VerdictRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const LabelSelect = styled.select`
  height: 34px;
  padding: 0 10px;
  border: 1px solid ${COLOR_SYSTEM.get("Gray")?.[100]};
  border-radius: 8px;
  background-color: ${COLOR_SYSTEM.get("Gray")?.[0]};
  color: ${COLOR_SYSTEM.get("Gray")?.[800]};
  font-size: 14px;
  align-self: flex-start;
`;

export const LabelTextarea = styled.textarea`
  width: 100%;
  min-height: 64px;
  padding: 8px 10px;
  border: 1px solid ${COLOR_SYSTEM.get("Gray")?.[100]};
  border-radius: 8px;
  font-size: 14px;
  resize: vertical;
  box-sizing: border-box;
`;

export const ScopeNote = styled.div`
  font-size: 12px;
  color: ${COLOR_SYSTEM.get("Gray")?.[500]};
`;

export const RuleNoteNotice = styled.div`
  font-size: 12px;
  color: ${COLOR_SYSTEM.get("Red")?.[600]};
`;

export const SameCaseNote = styled.div`
  font-size: 12px;
  color: ${COLOR_SYSTEM.get("Gray")?.[600]};
  cursor: help;
`;

export const SavedValue = styled.div`
  font-size: 12px;
  color: ${COLOR_SYSTEM.get("Gray")?.[700]};
`;

export const ViewLine = styled.div`
  font-size: 13px;
  color: ${COLOR_SYSTEM.get("Gray")?.[800]};
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const ViewMemo = styled.div`
  font-size: 13px;
  color: ${COLOR_SYSTEM.get("Gray")?.[600]};
  white-space: pre-wrap;
`;

export const NotLabelable = styled.div`
  font-size: 12px;
  color: ${COLOR_SYSTEM.get("Gray")?.[500]};
`;

export const Actions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const UnsavedBannerBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 14px;
  border: 1px solid ${COLOR_SYSTEM.get("Red")?.[200]};
  border-radius: 8px;
  background-color: ${COLOR_SYSTEM.get("Red")?.[50]};
`;

export const BannerText = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: ${COLOR_SYSTEM.get("Gray")?.[800]};
`;

export const BannerActions = styled.div`
  display: flex;
  gap: 8px;
`;
